// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__39hZ3","boxTitle":"Qualiphy_boxTitle__31axY","box":"Qualiphy_box__39Fz_","toggleWrap":"Qualiphy_toggleWrap__-jqWh"};